import React, {Component} from 'react';
import Modal from '@hig/modal';
import ProgressRing from '@hig/progress-ring';
import '@hig/progress-ring/build/index.css';
import '@hig/modal/build/index.css';
import "./callback.css";
import "../App";

class Callstatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //set the state of the variables
            variables: this.props.variablesFromCallback,
            showPopup: true,
            dataValue: this.props.dataValueFromApp,
            isLoading: false,
            modalOpen: true,
        }
    }
    cancelHandler(){
        this.setState({ modalOpen: false });
    }
    render(){
        //loading until the value is returned
        let data;
        if(this.state.isLoading){
           data = <div className='callback_popup'>
                    <div className='progress'>
                        <ProgressRing />
                    </div>
                </div>
        }
        else {
            // if there are any errors , else return the success message
            if(this.props.variablesFromCallback == 'noContactId'){
                data = <div className='modal'>
                    <Modal
                            style="standard"
                            onCloseClick={this.cancelHandler.bind(this)}
                            type="alternate"
                            title="Estimated Wait Time"
                            open={this.state.modalOpen}
                            >
                            <br></br>
                            <p>
                                Something Went Wrong, app might have updated remove your cache and try again
                            </p><br></br>
                    </Modal>
                </div>
            }
            else{
                data = <div className='modal'>
                        <Modal
                            style="standard"
                            onCloseClick={this.cancelHandler.bind(this)}
                            type="alternate"
                            title="Thank You"
                            open={this.state.modalOpen}
                            >
                            <br></br>
                            <p>
                            Your Details have been recorded. One of our agents will be in touch with you shortly.
                            </p>
                            <br></br>
                        </Modal>
                    </div>
            }
        }
        return(
            <div>
                {data}
            </div>
        );
    }
}

export default Callstatus;